/* eslint-disable import/first */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { MuiBox } from "../../../Box";
export function TabItem(_a) {
    var selectedValue = _a.selectedValue, index = _a.index, children = _a.children, minHeight = _a.minHeight, onClick = _a.onClick, rest = __rest(_a, ["selectedValue", "index", "children", "minHeight", "onClick"]);
    return (_jsx(MuiBox, __assign({ role: "tabpanel", hidden: selectedValue !== index, id: "simple-tabpanel-".concat(index), "aria-labelledby": "simple-tab-".concat(index), onClick: onClick }, rest, { children: selectedValue === index && (_jsx(MuiBox, __assign({ sx: { padding: "9px 0px", minHeight: minHeight } }, { children: _jsx(MuiBox, { children: children }) }))) })));
}
